import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { formatDateTime } from 'core/utils/date';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';
import { convertToPresenceAbsence } from 'core/components/common/converters';
import { FC } from 'react';

type Props = {
  /** 要請概要。 */
  requestSummary: IncidentDetailPatient['requestSummary'];
};

export const RequestSummaryView: FC<Props> = ({ requestSummary }) => (
  <BorderedContainer>
    <div className="flex flex-col gap-[24px]">
      <SectionTitle text="要請概要欄" />
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay title="発症時刻" content={requestSummary.onsetType} />
        <InfoDisplay
          title="発生日"
          content={
            requestSummary.onsetAt
              ? formatDateTime(requestSummary.onsetAt, 'yyyy/MM/dd')
              : ''
          }
        />
        <InfoDisplay title="発生時刻" content={requestSummary.onsetAtText} />
      </div>
      <div className="flex flex-col gap-6">
        <InfoDisplay title="主訴" content={requestSummary.chiefComplaint} />
        <InfoDisplay
          title="指令内容"
          content={requestSummary.telegramSummary}
        />
        <InfoDisplay title="原因" content={requestSummary.requestSummary} />
        <InfoDisplay
          title="現病歴・観察記録・傷病経過"
          content={requestSummary.clinicalCourse}
        />
        <InfoDisplay
          title="医薬品分類"
          content={<TagList tags={requestSummary.medicationStatusType} />}
        />
        <InfoDisplay
          title="服薬状況"
          content={
            <TagList
              tags={requestSummary.medicationStatus.map(
                status => status.medicationName ?? ''
              )}
            />
          }
        />
        <InfoDisplay
          title="服薬状況 自由入力欄"
          content={requestSummary.medicationStatusComment}
        />
        <InfoDisplay
          title="既往歴等"
          content={<TagList tags={requestSummary.medicalHistory} />}
        />
        <InfoDisplay
          title="既往歴等 自由入力欄"
          content={requestSummary.medicalHistoryComment}
        />
        <InfoDisplay
          title="かかりつけ医療機関"
          content={requestSummary.primaryCare}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="アレルギーの有無"
          content={convertToPresenceAbsence(requestSummary.allergyPresence)}
        />
        <InfoDisplay title="アレルギー" content={requestSummary.allergies} />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="最終食事日"
          content={requestSummary.lastMealComment}
        />
        <InfoDisplay title="要介護" content={requestSummary.adl} />
      </div>
    </div>
  </BorderedContainer>
);
